import { connect } from 'react-redux';

import {
  getParentOfferName,
  getParentOfferPath,
} from 'redux/modules/search-and-browse/selectors/get-breadcrumbs';
import getReasonForEmptyProductGrid from 'redux/modules/search/selectors/get-reason-for-empty';

import ProductGridEmpty from './ProductGridEmpty';

export default connect(state => ({
  pageType: 'offer',
  parentName: getParentOfferName(state),
  parentUrl: getParentOfferPath(state),
  reason: getReasonForEmptyProductGrid(state),
}))(ProductGridEmpty);
